import React, { useEffect, useState } from "react";
import { companyProfileLeftInThree, companyProfileMidInThree, companyProfileRightInThree, contactDirectoryLeftinThree, contactDirectoryMidinThree, contactDirectoryRightinThree } from "@/components/ads/GoogleAdsData";
import { parseAdData } from "@/shared/FunctionCore";
import { ad } from "@/components/ads/AdComponent";

const MarketPlaceAds = ({page}) => {
  const [googleAdsBannerLeft, setGoogleAdsBannerLeft] = useState();
  const [googleAdsBannerMid, setGoogleAdsBannerMid] = useState();
  const [googleAdsBannerRight, setGoogleAdsBannerRight] = useState();

  const setGoogleAdsForCompanyProfile = () => {
    const adComponentParameterLeft = {
      adData: parseAdData(companyProfileLeftInThree.ad),
      identifier: "",
      properties: { companyProfileLeftInThree },
    };
    setGoogleAdsBannerLeft(adComponentParameterLeft);

    const adComponentParameterMid = {
      adData: parseAdData(companyProfileMidInThree.ad),
      identifier: "",
      properties: { companyProfileMidInThree },
    };
    setGoogleAdsBannerMid(adComponentParameterMid);

    const adComponentParameterRight = {
      adData: parseAdData(companyProfileRightInThree.ad),
      identifier: "",
      properties: { companyProfileRightInThree },
    };
    setGoogleAdsBannerRight(adComponentParameterRight);
  }

  const setGoogleAdsForContactProfile = () => {
    const adComponentParameterLeft = {
      adData: parseAdData(contactDirectoryLeftinThree.ad),
      identifier: "",
      properties: { contactDirectoryLeftinThree },
    };
    setGoogleAdsBannerLeft(adComponentParameterLeft);

    const adComponentParameterMid = {
      adData: parseAdData(contactDirectoryMidinThree.ad),
      identifier: "",
      properties: { contactDirectoryMidinThree },
    };
    setGoogleAdsBannerMid(adComponentParameterMid);

    const adComponentParameterRight = {
      adData: parseAdData(contactDirectoryRightinThree.ad),
      identifier: "",
      properties: { contactDirectoryRightinThree },
    };
    setGoogleAdsBannerRight(adComponentParameterRight);
  }


  useEffect(() => {
    if(page==='ContactProfile') {
      setGoogleAdsForContactProfile();
    }

    if(page==='CompanyProfile') {
      setGoogleAdsForCompanyProfile()
    }
  }, []);

  return (
    <>
      <div className="component-wrapper marketplace-ads">
        <div className="container">
          <div className="row">
              <div className="col-md-4">
                <div className="colPar0 parsys">
                  {ad({ adComponentParameter: googleAdsBannerLeft })}
                </div>
              </div>
              <div className="col-md-4">
                <div className="colPar0 parsys">
                  {ad({ adComponentParameter: googleAdsBannerMid })}
                </div>
              </div>
              <div className="col-md-4">
                <div className="colPar0 parsys">
                  {ad({ adComponentParameter: googleAdsBannerRight })}
                </div>
              </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketPlaceAds;
